module.exports = __webpack_public_path__ + "img/eth-circle-logo.4568a899.svg";